import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { Info } from '../../../icons';
import { ReviewStatus } from '@ugc-components/ugc-pdp-review/interface';

@Component({
  tag: 'ugc-review-pending-status',
  shadow: false,
})
export class UgcReviewPendingStatus {
  getMessage = () => {
    const {
      reviewStaticLanguage: {
        IDS_UGC_PENDING_REWARDS_TIP = '',
        IDS_MY_REVIEW_PENDING = '',
        IDS_UGC_SUBMITTED_REVIEW_TIP = '',
      },
      userReviewData: { status = 0, isFrozen = false },
    } = state;
    const isApproved = status === ReviewStatus.Approved;
    const isInprogress = status === ReviewStatus.InProcess;
    const isForReview = status === ReviewStatus.ForReview;
    if (isFrozen) {
      if (isApproved) {
        return IDS_UGC_PENDING_REWARDS_TIP;
      }
      if (isInprogress) {
        return IDS_UGC_SUBMITTED_REVIEW_TIP;
      }
      return IDS_MY_REVIEW_PENDING;
    }
    if (isForReview) {
      return IDS_MY_REVIEW_PENDING;
    }
  };
  render() {
    const { isDesktop } = state;

    const message = this.getMessage();
    return (
      <div class="flex-row-start-start border-1 border-solid border-gray-300 rounded-8 p-8 gap-8 bg-gray-100 mb-8">
        <Info />
        <div class={`${isDesktop ? 'fs-14' : 'fs-12'} color-gray-700`} innerHTML={message} />
      </div>
    );
  }
}
